import React, { useEffect, useRef, useState } from "react";

/**
 * Renders `text` inside a fixed-width, non-wrapping box.
 * If the text is wider than the box, it auto-scrolls back and forth
 * (ping-pong) so the full label is readable without resizing the
 * surrounding layout. If it fits, it just sits still.
 *
 * Usage: <ScrollingText text={city.name} widthClass="w-[90px]" />
 */
export default function ScrollingText({ text, widthClass = "w-full", className = "" }) {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [shift, setShift] = useState(0);

  useEffect(() => {
    const container = containerRef.current;
    const el = textRef.current;
    if (container && el) {
      const diff = el.scrollWidth - container.clientWidth;
      setShift(diff > 2 ? diff : 0);
    } else {
      setShift(0);
    }
  }, [text, widthClass]);

  return (
    <span
      ref={containerRef}
      className={`inline-block overflow-hidden whitespace-nowrap align-middle ${widthClass} ${className}`}
    >
      <span
        ref={textRef}
        className={`inline-block ${shift > 0 ? "marquee-text" : ""}`}
        style={shift > 0 ? { "--marquee-shift": `-${shift}px` } : undefined}
      >
        {text}
      </span>
    </span>
  );
}
